module.exports = __webpack_public_path__ + "img/icon4.de55e9ed.png";